import { AfterViewInit, Component, effect, inject, OnDestroy, OnInit, OutputEmitterRef, Signal, TemplateRef } from '@angular/core';

import { _SectionCompactComponent } from 'src/app/infrastructure/components/section-components/_section-compact-component';
import { IFooterData } from 'src/app/features/shared/footer/models/footer-data';
import { IHeaderData } from 'src/app/features/shared/header/models/header-data';
import { firstFilled, userNameCompose } from 'src/app/infrastructure/functions/user-name.function';
import { _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service';
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { _CentralPageService } from 'src/app/features/shared/central-page/services/_central-page.service';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { FooterService } from 'src/app/features/shared/footer/footer.service';
import { HeaderService } from 'src/app/features/shared/header/services/header.service';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { accountData, IAccountData } from '../../models/account-data';

@Component({
    selector: 'app-account-compact',
    templateUrl: './account-compact.component.html',
    styleUrls: [
        '../../../../shared/central-page/components/compact-section.scss',
        './account-compact.component.scss',
    ],
    standalone: true,
})
export class AccountCompactComponent
    extends _SectionCompactComponent<IAccountData>
    implements OnInit, AfterViewInit
{
    protected override readonly _centralPageService = injectRequired(_CentralPageService);
    protected override readonly _footerService = injectRequired(FooterService);
    protected override readonly _formModelService = injectRequired(_FormModelService);
    protected override readonly _headerService = injectRequired(HeaderService);
    protected override readonly _loadingPageService = injectRequired(LoadingPageService);
    protected override readonly _pageService = injectRequired(_PageService);

    override out_onEscape = this._out_onEscape;
    override out_onPageLoaded = this._out_onPageLoaded;

    override footerData: Partial<IFooterData> = {
        hideSideBlockLeft: false,
        hideSideBlockRight: false,
    };
    override headerData: Partial<IHeaderData> = {
        sideBlockRight_hide: false,
        sideBlockLeft_noClick: true,
        subTitle_hide: true,
        title: routePage.home,
    };
    override dataModel$$ = this._dataModel$$;
    override template_footerLeft$$ = this._template_footerLeft$$;
    override template_sectionDetails_extraButtons$$ = this._template_sectionDetails_extraButtons$$;
    override template_sectionEdit_extraButtons$$ = this._template_sectionEdit_extraButtons$$;

    name: string | null = null;
    firstName: string | null = null;
    lastName: string | null = null;
    email: string | null = null;

    constructor() {
        super();
        
        effect(() => {
            const __dataModel = this.dataModel$$();
            if (!__dataModel) return;
            
            this.firstName = __dataModel[accountData.firstName];
            this.lastName = __dataModel[accountData.lastName];
            this.email = __dataModel[accountData.email];
            // Zelfde keten als wat anderen zien (userDisplayName): applicationName → firstName + lastName → email.
            this.name = firstFilled(__dataModel[accountData.applicationName], userNameCompose(this.firstName, this.lastName), this.email)
        })
    }
 
    override ngOnInit(): void {
        super._ngOnInit();
    }
    
    override emit_onEscape(): void {
        super._emit_onEscape();
    }
    
    override emit_pageLoaded(): void {
        super._emit_pageLoaded();
    }
    
    override ngAfterViewInit(): void {
        super._ngAfterViewInit();
    }
}

